// extracted by mini-css-extract-plugin
module.exports = {"select":"Select_select__hhi0_","right":"Select_right__18Qrl","load":"Select_load__20KGq"};